import React from 'react';
import { IconActionArrowRight as IconActionArrowRightOriginal } from '@cko/icons';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
const TruncatedText = styled.p `
  margin: var(--layout-sandgrain);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: inherit;
`;
const IconActionArrowRight = styled(IconActionArrowRightOriginal) `
  display: block;
  min-width: 16px;
  margin-left: var(--layout-seed);
`;
const InternalLinkStyled = styled(Link) `
  display: flex;
  align-items: center;
  color: var(--action-text-primary);
  text-decoration: none;
  overflow: hidden;

  & > svg > g {
    fill: var(--action-icon-primary);
  }

  &:hover {
    color: var(--action-text-hover);
    text-decoration: underline;
  }

  &:hover > svg > g {
    fill: var(--action-icon-hover);
  }
`;
export const InternalLink = ({ children, includeIcon = true, to }) => {
    return (React.createElement(InternalLinkStyled, { to: to },
        React.createElement(TruncatedText, null, children),
        ' ',
        includeIcon && React.createElement(IconActionArrowRight, { "data-testid": "internal-link-icon" })));
};
